import { useContext } from "react";
import LoaderBrand from "./LoaderBrand";
import PageLoader from "./PageLoader";
import { ActiveLoaderBrandingContext } from "../context/LoaderBrandingContext";
import "./globalRequestLoader.css";

/** Shared presentation for startup screens and the blocking request overlay. */
export function BrandedLoaderPanel({ brand: suppliedBrand, label, hint }) {
  const activeBrand = useContext(ActiveLoaderBrandingContext);
  const brand = suppliedBrand === undefined ? activeBrand : suppliedBrand;
  return <div className="global-request-panel"><LoaderBrand brand={brand} /><PageLoader showBrand={false} label={label} hint={hint} /></div>;
}

export default function FullPageLoader({ brand, label = "Loading…", hint }) {
  const activeBrand = useContext(ActiveLoaderBrandingContext);
  const resolved = brand === undefined ? activeBrand : brand;
  return <div className="branded-page-loader" data-testid="branded-page-loader" data-neutral={!resolved?.name}>
    <BrandedLoaderPanel brand={resolved} label={label} hint={hint} />
  </div>;
}
